<div class="container">
  <mat-spinner [diameter]="86"></mat-spinner>
</div>
